import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Icon } from "@project/ui";
import { DEFAULT_LOCALE, getTranslation } from "@project/i18n";
import { authClient } from "@apps/dashboard/lib/auth-client";
import { hasValidAuthSession } from "@apps/dashboard/lib/auth-session";

const loadingLabel = getTranslation(DEFAULT_LOCALE).common.loading;

/**
 * Exige sesión Better Auth: GET /api/auth/get-session con cookies (credentials: include).
 * Sin sesión válida → /login (estado `from` para volver tras iniciar sesión).
 *
 * El texto de carga usa `getTranslation(DEFAULT_LOCALE)` (sin `useI18n`) para evitar fallos
 * si el contexto i18n no está disponible (p. ej. HMR o orden de providers).
 */
export function ProtectedRoute(): JSX.Element {
  const { data, isPending } = authClient.useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface text-on-surface">
        <Icon name="LoaderCircle" className="size-10 animate-spin text-primary" strokeWidth={1.5} aria-hidden />
        <p className="text-body-md text-on-surface-variant">{loadingLabel}</p>
      </div>
    );
  }

  if (!hasValidAuthSession(data)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
